import { createDraftSafeSelector } from "@reduxjs/toolkit";

import { RootState } from "../../../store-types";
import { ISeedsState } from "../shared";

import { SEEDS_MODULE_NAME } from "./constants";

export const getSeedsState = (rootState: RootState): ISeedsState =>
  rootState[SEEDS_MODULE_NAME];

export const getSearchText = createDraftSafeSelector(
  getSeedsState,
  (state: ISeedsState) => state.searchText
);
